import {RichText} from "prismic-reactjs"; 

export default ({ data, id, slugs }) => ({
	id,
	slug: slugs[0],
    our_story: RichText.render(data.our_story),
});
